import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function ReferralForm() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        <section className="bg-gradient-to-br from-[#0f1e32] to-[#1e3a5f] text-white py-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
            <h1 className="text-6xl font-bold mb-8">Physician Referral Form</h1>
            <p className="text-xl text-gray-100 leading-relaxed mb-10">
              Please use the referral form below to submit infusion therapy referrals to Zeus Specialty Infusion Center.
            </p>
            
            <div className="mb-12">
              <a href="#" className="inline-block">
                <Button variant="secondary" size="lg" className="!px-10 !py-4 !text-lg">
                  <i className="ri-download-line mr-2"></i>
                  Download Referral Form
                </Button>
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 inline-block">
              <ul className="text-left space-y-4 text-lg">
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl"></i>
                  <span>Same-week treatment availability</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl"></i>
                  <span>Complete authorization &amp; benefits management</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl"></i>
                  <span>Real-time clinical communication</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
